var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31162 8.98144C4.11723 9.17757 4.11865 9.49415 4.31478 9.68854C4.51091 9.88293 4.82749 9.88152 5.02188 9.68539L6.18675 8.51008C6.65951 8.03308 6.98487 7.70588 7.26055 7.48448C7.52835 7.26941 7.70036 7.19563 7.85441 7.176C7.95114 7.16367 8.04902 7.16367 8.14575 7.176C8.2998 7.19563 8.47181 7.26941 8.73961 7.48448C9.0153 7.70588 9.34066 8.03308 9.81341 8.51007L10.9783 9.68539C11.1727 9.88152 11.4893 9.88293 11.6854 9.68854C11.8815 9.49415 11.8829 9.17757 11.6885 8.98144L10.5027 7.78496C10.0561 7.33431 9.69102 6.96599 9.36577 6.70479C9.02756 6.43317 8.68426 6.23655 8.27219 6.18402C8.0915 6.16099 7.90866 6.16099 7.72797 6.18402C7.3159 6.23655 6.9726 6.43317 6.63439 6.70479C6.30914 6.96599 5.94412 7.33429 5.4975 7.78493L4.31162 8.98144Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 15.1667C11.9581 15.1667 15.1667 11.9581 15.1667 8.00008C15.1667 4.04204 11.9581 0.833416 8.00008 0.833417C4.04204 0.833417 0.833415 4.04204 0.833415 8.00008C0.833416 11.9581 4.04204 15.1667 8.00008 15.1667ZM14.1667 8.00008C14.1667 11.4058 11.4058 14.1667 8.00008 14.1667C4.59433 14.1667 1.83342 11.4058 1.83342 8.00008C1.83342 4.59433 4.59432 1.83342 8.00008 1.83342C11.4058 1.83342 14.1667 4.59433 14.1667 8.00008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowUp);
export default __webpack_public_path__ + "static/media/circle-arrow-up.383971a695cd508eb777bfa69a3cf249.svg";
export { ForwardRef as ReactComponent };